"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardType_1 = require("@/common/cards/CardType");
const utils_1 = require("@/common/utils/utils");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const ClientGlobalEventManifest_1 = require("@/client/turmoil/ClientGlobalEventManifest");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const AllColonies_1 = require("@/common/colonies/AllColonies");
const GameModule_1 = require("@/common/cards/GameModule");
const Tag_1 = require("@/common/cards/Tag");
const ClientColonyManifest_1 = require("@/client/colonies/ClientColonyManifest");
const i18n_1 = require("@/client/directives/i18n");
const MilestoneName_1 = require("@/common/ma/MilestoneName");
const AwardName_1 = require("@/common/ma/AwardName");
const CardListModel_1 = require("@/client/components/cardlist/CardListModel");
const MilestoneAwardManifest_1 = require("@/client/MilestoneAwardManifest");
const Types_1 = require("@/common/turmoil/Types");
const Card_vue_1 = require("@/client/components/card/Card.vue");
const Colony_vue_1 = require("@/client/components/colonies/Colony.vue");
const GlobalEvent_vue_1 = require("@/client/components/turmoil/GlobalEvent.vue");
const PreferencesIcon_vue_1 = require("@/client/components/PreferencesIcon.vue");
const Milestone_vue_1 = require("@/client/components/Milestone.vue");
const Award_vue_1 = require("@/client/components/Award.vue");
const TurmoilAgenda_vue_1 = require("@/client/components/turmoil/TurmoilAgenda.vue");
const CardResource_1 = require("@/common/CardResource");
const cardResources_1 = require("../common/cardResources");
exports.default = vue_1.default.extend({
    name: 'card-list',
    components: {
        Card: Card_vue_1.default,
        GlobalEvent: GlobalEvent_vue_1.default,
        Colony: Colony_vue_1.default,
        Milestone: Milestone_vue_1.default,
        Award: Award_vue_1.default,
        TurmoilAgenda: TurmoilAgenda_vue_1.default,
        PreferencesIcon: PreferencesIcon_vue_1.default,
    },
    data() {
        return (0, CardListModel_1.hashToModel)(window.location.hash);
    },
    mounted() {
        this.$refs.filter.focus();
        this.delayedSetLocationHash();
    },
    computed: {
        allModules() {
            return GameModule_1.GAME_MODULES;
        },
        allTypes() {
            return [
                CardType_1.CardType.EVENT,
                CardType_1.CardType.ACTIVE,
                CardType_1.CardType.AUTOMATED,
                CardType_1.CardType.PRELUDE,
                CardType_1.CardType.CORPORATION,
                CardType_1.CardType.STANDARD_PROJECT,
                CardType_1.CardType.CEO,
                'colonyTiles',
                'globalEvents',
                'milestones',
                'awards',
                'agendas',
            ];
        },
        allTags() {
            const results = [];
            for (const tag in Tag_1.Tag) {
                if (Object.prototype.hasOwnProperty.call(Tag_1.Tag, tag)) {
                    results.push(Tag_1.Tag[tag]);
                }
            }
            return results.concat('none');
        },
        allResources() {
            return [...(0, utils_1.getEnumStringValues)(CardResource_1.CardResource), 'none'];
        },
        allMilestoneNames() {
            return [...MilestoneName_1.milestoneNames].sort();
        },
        allAwardNames() {
            return [...AwardName_1.awardNames].sort();
        },
        allAgendaIds() {
            const ids = Types_1.POLICY_IDS.concat(Types_1.BONUS_IDS);
            const [official, expansion] = (0, utils_1.partition)(ids, (id) => id.endsWith('01'));
            official.sort();
            expansion.sort();
            return [...official, ...expansion];
        },
        cardResourceCSS() {
            return cardResources_1.cardResourceCSS;
        },
    },
    methods: {
        delayedSetLocationHash(delayms = 200) {
            setTimeout(() => {
                const changed = this.setLocationHash();
                this.delayedSetLocationHash(changed ? 10 : 100);
            }, delayms);
        },
        setLocationHash() {
            const hash = (0, CardListModel_1.modelToHash)(this);
            const changed = hash !== window.location.hash;
            window.location.hash = hash;
            return changed;
        },
        invertExpansions() {
            GameModule_1.GAME_MODULES.forEach((module) => this.expansions[module] = !this.expansions[module]);
        },
        invertTags() {
            this.allTags.forEach((tag) => this.tags[tag] = !this.tags[tag]);
        },
        invertResources() {
            this.allResources.forEach((resource) => this.resources[resource] = !this.resources[resource]);
        },
        invertTypes() {
            this.allTypes.forEach((type) => this.types[type] = !this.types[type]);
        },
        sort(names) {
            if (this.sortOrder === 'a') {
                const translated = names.map((name) => ({ name: name, text: (0, i18n_1.translateText)(name) }));
                translated.sort((a, b) => a.text.localeCompare(b.text));
                return translated.map((e) => e.name);
            }
            else {
                const numbered = names.map((name) => ({ name: name, number: (0, ClientCardManifest_1.getCardOrThrow)(name).metadata.cardNumber ?? '' }));
                numbered.sort((a, b) => a.number.localeCompare(b.number));
                return numbered.map((e) => e.name);
            }
        },
        getAllStandardProjectCards() {
            const names = (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.STANDARD_PROJECT)).map(utils_1.toName);
            return this.sort(names);
        },
        getAllProjectCards() {
            const names = [];
            names.push(...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.AUTOMATED)).map(utils_1.toName));
            names.push(...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.ACTIVE)).map(utils_1.toName));
            names.push(...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.EVENT)).map(utils_1.toName));
            return this.sort(names);
        },
        getAllCorporationCards() {
            const names = (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.CORPORATION)).map(utils_1.toName);
            return this.sort(names);
        },
        getAllPreludeCards() {
            const names = (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.PRELUDE)).map(utils_1.toName);
            return this.sort(names);
        },
        getAllCeoCards() {
            const names = (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.CEO)).map(utils_1.toName);
            return this.sort(names);
        },
        getAllGlobalEvents() {
            if (this.sortOrder === 'a') {
                return this.sort(Array.from((0, ClientGlobalEventManifest_1.allGlobalEventNames)()));
            }
            else {
                return Array.from((0, ClientGlobalEventManifest_1.allGlobalEventNames)());
            }
        },
        getAllColonyNames() {
            return AllColonies_1.OFFICIAL_COLONY_NAMES.concat(AllColonies_1.COMMUNITY_COLONY_NAMES).concat(AllColonies_1.PATHFINDERS_COLONY_NAMES);
        },
        include(name, type) {
            const normalized = this.filterText.toLocaleUpperCase();
            if (normalized.length === 0) {
                return true;
            }
            if (this.namesOnly) {
                return name.toLocaleUpperCase().includes(normalized);
            }
            else {
                return this.searchIndex.matches(this.filterText, type, name);
            }
        },
        expansionIconClass(expansion) {
            switch (expansion) {
                case 'base': return 'expansion-icon-base';
                case 'corpera': return 'expansion-icon-CE';
                case 'colonies': return 'expansion-icon-colony';
                case 'moon': return 'expansion-icon-themoon';
                default: return `expansion-icon-${expansion}`;
            }
        },
        filterByTags(card) {
            if (card.tags.length === 0) {
                return this.tags['none'] === true;
            }
            let matches = false;
            for (const tag of card.tags) {
                if (this.tags[tag])
                    matches = true;
            }
            return matches;
        },
        showCard(cardName) {
            if (!this.include(cardName, 'card'))
                return false;
            const card = (0, ClientCardManifest_1.getCard)(cardName);
            if (card === undefined) {
                return false;
            }
            if (!this.filterByTags(card))
                return false;
            if (!this.types[card.type])
                return false;
            if (card.resourceType === undefined) {
                if (this.resources.none === false) {
                    return false;
                }
            }
            else {
                if (!this.resources[card.resourceType])
                    return false;
            }
            switch (this.vps) {
                case 1:
                    if (card.victoryPoints === undefined) {
                        return false;
                    }
                    break;
                case 2:
                    if (card.victoryPoints !== undefined) {
                        return false;
                    }
                    break;
            }
            return this.expansions[card.module] === true;
        },
        showGlobalEvent(name) {
            if (!this.include(name, 'globalEvent'))
                return false;
            const globalEvent = (0, ClientGlobalEventManifest_1.getGlobalEvent)(name);
            return globalEvent !== undefined && this.expansions[globalEvent.module] === true;
        },
        showColony(name) {
            if (!this.include(name, 'colony'))
                return false;
            const colony = (0, ClientColonyManifest_1.getColony)(name);
            return colony !== undefined && this.expansions[colony.module ?? 'base'] === true;
        },
        showMilestone(name) {
            if (!this.include(name, 'ma')) {
                return false;
            }
            return this.expansions[(0, MilestoneAwardManifest_1.getMilestone)(name).requirements ?? 'base'] === true;
        },
        showAward(name) {
            if (!this.include(name, 'ma')) {
                return false;
            }
            return this.expansions[(0, MilestoneAwardManifest_1.getAward)(name).requirements ?? 'base'] === true;
        },
        getLanguageCssClass() {
            const language = (0, PreferencesManager_1.getPreferences)().lang;
            return 'language-' + language;
        },
        colonyModel(colonyName) {
            return {
                colonies: this.showMetadata ? ['red', 'blue'] : [],
                isActive: this.showMetadata,
                name: colonyName,
                trackPosition: 3,
                visitor: undefined,
            };
        },
        milestoneModel(name) {
            return { name, playerName: undefined, color: undefined, scores: [] };
        },
        awardModel(name) {
            return { name, playerName: undefined, color: undefined, scores: [] };
        },
        experimentalUI() {
            return (0, PreferencesManager_1.getPreferences)().experimental_ui;
        },
        toggleNamesOnly() {
            this.namesOnly = !this.namesOnly;
        },
        toggleAdvancedSearch() {
            this.showAdvanced = !this.showAdvanced;
        },
        toggleSortOrder() {
            this.sortOrder = this.sortOrder === 'a' ? '1' : 'a';
        },
        toggleVps() {
            this.vps = (this.vps + 1) % 3;
        },
        toggleShowMetadata() {
            this.showMetadata = !this.showMetadata;
        },
    },
});
